"use client";

import { EmbeddedProvider } from "@/components/EmbeddedContext";

export const EmbeddedProviderWrapper: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return <EmbeddedProvider isEmbedded={true}>{children}</EmbeddedProvider>;
};
